import { render, staticRenderFns } from "./SingleSparkleIcon.vue?vue&type=template&id=dec913c6&"
import script from "./SingleSparkleIcon.vue?vue&type=script&lang=js&"
export * from "./SingleSparkleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports